import {
    Box,
    Button,
    MenuItem,
    Modal,
    Select,
    Typography,
  } from "@mui/material";
  import axios from "axios";
  import React, { useEffect, useState } from "react";
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  function AddProduct2({
    openProduct2,
    closehandleProduct2,
    singleData,
    dataArray,
    setDataArray,
  }) {
    console.log(singleData);
    const [productList, setProductList] = useState();
    const [productName, setProductName] = useState("");
    useEffect(() => {
      axios
        .get(
          `/api/partners/products?page=1&limit=100&partner_name=${singleData?.second_partner}`
        )
        .then((response) => {
          const temp = [];
          console.log(response?.data?.products?.rows);
          {
            response?.data?.products?.rows?.map((item, index) =>
              temp.push(item?.product_name)
            );
          }
          console.log(temp);
          setProductList(temp);
        })
        .catch((error) => {
          console.log(error);
        });
    }, [singleData]);
   
    const handleSelectproduct = (e) => {
      setProductName(e.target.value);
    };
    
    const addHandler = () => {
      const updatedArray = dataArray.map((obj) => {
        if (obj.order_id === singleData?.order_id) {
          return { ...obj, lending_partner_2_product: productName };
        }
        return obj;
      });
      console.log(updatedArray)
      setDataArray([...updatedArray]);
      setProductName("")
      closehandleProduct2()
    };
    return (
      <div>
        <Modal
          open={openProduct2}
          onClose={closehandleProduct2}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            
            {productList?.length>0? 
            <div>
              <Typography id="modal-modal-title" variant="h6" component="h2">
              Select product
            </Typography><Select
            className="mt-3"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Select"
            onChange={(e) => handleSelectproduct(e)}
          >
            {productList?.map((item, index) => (
              <MenuItem value={item}>{item}</MenuItem>
            ))}
          </Select></div>
            :<div className="mt-2 fw-bolder">{`No Products for ${singleData?.second_partner}`}</div>}
           
            <div className="mt-4 d-flex justify-content-start gap-3 ">
              <Button variant="contained" onClick={addHandler}>
                Add
              </Button>
              <Button variant="contained" onClick={()=>closehandleProduct2()}>Cancel</Button>
            </div>
          </Box>
        </Modal>
      </div>
    );
  }
  
  export default AddProduct2;
  